module.exports = __webpack_public_path__ + "static/brazil-e090edcf2511cd743faa99f09d6c9b61.png";